import './conversion-log-table.dialog.component.scss'
import {ConversionLogFilter} from "../../model/ConversionLogFilter";
import * as angular from "angular";

export class ConversionLogTableDialog {
    static instance = (filter: ConversionLogFilter):angular.material.IDialogOptions => ({
        template: require('./conversion-log-table.dialog.component.html'),
        controller: [
            'filter',
            '$mdDialog',
            ConversionLogTableDialog
        ],
        locals: {
            filter: filter
        },
        clickOutsideToClose: true,
        controllerAs: '$ctrl'
    });

    constructor(private filter: ConversionLogFilter,
                private $mdDialog: angular.material.IDialogService) {
    }

    closeDialog = () => {
        return this.$mdDialog.hide();
    }

}